import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

export const login = ({ payload }) => {
  const url = apiURl + "auth/login";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload.user),
  };

  return fetchAndReturn(url, parameters);
};

export const getUser = (token) => {
  const url = apiURl + "auth/getUser";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export const register = (user, token) => {
  const url = apiURl + "users/register";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // 'Authorization' : 'Bearer ' + token,
    },
    body: JSON.stringify(user),
  };

  return fetchAndReturn(url, parameters);
};
